import fetchJSON from '@api/api_helper';

const getUrl = (attachmentKey) => `/api/v4/attachments/${attachmentKey}`;

export const get = (attachmentKey, options) => (
  fetchJSON(getUrl(attachmentKey), options)
    .then(({ data }) => data)
    .catch(async (response) => { throw (await response.json()); })
);

const updateAttachment = (options) => {
  const url = getUrl(options.attachmentKey);
  const appendedOptions = {
    method: 'PUT',
    body: { data: options.data },
    context: options.context
  };

  return fetchJSON(url, appendedOptions);
};

export const deleteAttachment = (attachmentKey) => {
  const url = getUrl(attachmentKey);
  const appendedOptions = {
    method: 'DELETE'
  };

  return fetchJSON(url, appendedOptions);
};

export default updateAttachment;
